import { render } from "./BurgerMenu.vue?vue&type=template&id=519d9db3&scoped=true"
const script = {}

import "./BurgerMenu.vue?vue&type=style&index=0&id=519d9db3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519d9db3"]])

export default __exports__